import api from '@/utils/api';

export async function getShowrooms() {
  return api.get('api/v1/showrooms/');
}

export async function updateShowroom(id: number) {
  return api.post('accounts/update_session_showroom/', `id=${id}`, {
    headers: { 'content-type': 'application/x-www-form-urlencoded; charset=UTF-8' },
  });
}
